/**
 * PlayerProgressBar Component
 */

import { getFormattedTime } from '../../../../utils/date';
import { getRelativeCoordinates } from '../../../../utils/dom';

import { throttle } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import * as WindowSizeListener from 'react-window-size-listener';

import { Span } from '../../../atoms/text/Label';

interface IOwnProps {
  duration: number;
  elapsedTime: number;
  metadataLoaded: boolean;
  onDragStart?: () => any;
  onDragEnd?: () => any;
  onSeek: (percentage: number) => any;
  remainingTime: number;
}

interface IOwnState {
  dragPosition: number;
  isDragging: boolean;
  progressBarClip: number;
}

const classes = new BEM('player');

export default class PlayerProgressBar extends React.Component<IOwnProps, IOwnState> {
  private progressBarRef: HTMLElement;
  private hitzone: HTMLElement;
  private onDragThrottled;

  constructor(props) {
    super(props);

    this.onDragThrottled = throttle(this.onDrag, 20);
    this.state = {
      dragPosition: 0,
      isDragging: false,
      progressBarClip: 0,
    };
  }

  componentWillReceiveProps(nextProps: IOwnProps) {
    if (nextProps.elapsedTime !== this.props.elapsedTime) {
      this.setState({
        progressBarClip: (nextProps.elapsedTime / nextProps.duration) * this.progressBarRef.clientWidth,
      });
    }
  }

  onClickSeek = (e) => {
    const positionX = this.getCurrentPositionX(e);
    this.props.onSeek(positionX / this.hitzone.clientWidth);
  }

  onDragStart = (e) => {
    this.setState({
      isDragging: true,
      dragPosition: this.getCurrentPositionX(e),
    }, () => {
      if (this.props.onDragStart) {
        this.props.onDragStart();
      }
    });
  }

  onDrag = (e: React.DragEvent<HTMLDivElement>) => {
    const positionX = this.getCurrentPositionX(e);
    const glitchThreshold = 100;
    // Make sure the new cursor position is not a glitch before setting the drag position
    if (Math.abs(positionX - this.state.dragPosition) < glitchThreshold) {
      this.setState({ dragPosition: positionX });
    }
  }

  onDragEnd = (e) => {
    this.props.onSeek(this.state.dragPosition / this.hitzone.clientWidth);
    setTimeout(() => {
      this.setState({ isDragging: false }, () => {
        if (this.props.onDragEnd) {
          this.props.onDragEnd();
        }
      });
    }, 250);
  }

  onResize = () => {
    this.setState({
      progressBarClip: (this.props.elapsedTime / this.props.duration) * this.progressBarRef.clientWidth,
    });
  }

  render() {
    const {
      elapsedTime,
      // metadataLoaded,
      remainingTime,
    } = this.props;

    return (
      <div {...classes('track-progress') }>
        <WindowSizeListener onResize={this.onResize} />
        <Span
          text={getFormattedTime(elapsedTime)}
          size="xsmall"
          {...classes('track-progress__duration', 'elapsed') }
        />
        <div {...classes('progress-bar') }>
          <div
            {...classes('progress-bar__hitzone') }
            ref={(node) => this.hitzone = node!}
            draggable
            onClick={this.onClickSeek}
            onDragStart={this.onDragStart}
            onDragEnd={this.onDragEnd}
            onDrag={(e) => {
              e.persist();
              this.onDragThrottled(e);
            }}
          />
          <div {...classes('progress-bar__tracker') } />
          <div
            ref={(node) => this.progressBarRef = node!}
            {...classes('progress-bar__progress') }
            style={this.getProgressBarClip()}
          />
          {/* {!metadataLoaded && <div {...classes('progress-bar__buffer') } />} */}
        </div>
        <Span
          text={`-${getFormattedTime(Math.abs(remainingTime))}`}
          size="xsmall"
          {...classes('track-progress__duration', 'remaining') }
        />
      </div>
    );
  }

  private getCurrentPositionX(e) {
    return getRelativeCoordinates(this.hitzone, e).x;
  }

  private getProgressBarClip() {

    const {
      dragPosition,
      isDragging,
      progressBarClip,
    } = this.state;

    const progressBarStyle = {
      clip: 'rect(0 0 2px 0)',
    };

    if (this.progressBarRef) {
      const progressBarWidth = isDragging ? dragPosition : progressBarClip;
      const progressBarHeight = this.progressBarRef.clientHeight;
      progressBarStyle.clip = `rect(0 ${progressBarWidth}px ${progressBarHeight}px 0)`;
    }

    return progressBarStyle;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/Player/PlayerProgressBar.tsx